import { AnalyticsStore, codeSplit, Controller, FetchOptions, FetchPageOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';
import analyticsUtil from '../util/AnalyticsUtil';

import { pageNames } from '../data/page-names';

export class HomeController implements Controller {
  public pageId = pageNames.home;
  public path = '/:localeName?/home';
  public routeName = 'home';
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "home-page" */ '../views/home-page'));
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    const stores = options.stores;
    const { request } = options;
    const analyticsStore: AnalyticsStore = stores && stores.get<AnalyticsStore>('analytics');

    const context = request.context;

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, context);

    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(options: FetchPageOptions): Promise<PageData> {
    const { request } = options;

    const pageData = {
      title: 'Expedia Affiliate Program',
    };

    if (request.context.locale !== 'en_US') {
      pageData['seo'] = { robots: 'noindex' };
    }

    return Promise.resolve(pageData) as Promise<PageData>;
  }
}
